export default __webpack_public_path__ + "static/media/i2400.a9ca5c69.jpg";